// extracted by mini-css-extract-plugin
module.exports = {"SubscriptionSettingsContainer":"styles_SubscriptionSettingsContainer__2U5Y9"};